MemberState = require 'app/scripts/view-models/member-state'
{ track, trackUe, Noun, Verb } = require '@trello/analytics'
stickerClip = require 'app/scripts/lib/util/sticker-clip'
StickerView = require 'app/scripts/views/stickers/sticker-view'
CustomFieldBadgesView = require 'app/scripts/views/custom-field/custom-field-badges-view'
PluginBadgesView = require 'app/scripts/views/plugin/plugin-badges-view'
CARD_AGING_POWER_UP_ID = require('app/scripts/data/legacy-power-ups').cardAging

module.exports.addNewStickerToList = (sticker, left, top, rotate) ->
  image = sticker.id ? sticker.get('image')
  imageUrl = sticker.get('url')
  imageScaled = sticker.get('scaled')
  isGiphySticker = sticker.get('isGiphySticker')

  if isGiphySticker
    useAnimatedStickers = MemberState.getUseAnimatedStickers()
    if !useAnimatedStickers
      image = sticker.get('stillUrl')
      imageUrl = sticker.get('stillUrl')
      imageScaled = sticker.get('stillScaled')

    trackUe({
      category: Noun.CARD,
      verb: Verb.ADDS,
      directObj: Noun.GIPHY_STICKER,
      context: {
        useAnimatedStickers
      },
    })

  track("Card", "Sticker", image, @model.trackProperty())

  @model.stickerList.create
    image: image
    left: stickerClip(left)
    top: stickerClip(top)
    rotate: rotate
    zIndex: @model.stickerList.nextZIndex()
    imageUrl: imageUrl
    imageScaled: imageScaled
    isGiphySticker: isGiphySticker
  ,
    modelCache: @modelCache

  return

module.exports.showStickers = ->
  !@onCalendar

module.exports.renderStickers = (e) ->
  if !@showStickers()
    @$el.removeClass('is-stickered')
    return

  $stickersArea = @$('.js-stickers-area')
  $stickers = @$('.js-card-stickers')

  hasStickers = @model.hasStickers()
  editable = @model.editable()

  if hasStickers
    @$el.addClass('is-stickered')
    $stickersArea.removeClass('hide')
    stickerSubViews = @model.stickerList.map (sticker) =>
      @subview StickerView, sticker, {
        canRemove: editable && sticker.id && !@options.quickEditHidden
        fixedHeight: =>
          @$('.js-card-details').get(0).getBoundingClientRect().top -
          $stickersArea.get(0).getBoundingClientRect().top
        # Width of a card, without overlapping the edit control if edit control exists
        fixedWidth: =>
          stickerRect = $stickersArea.get(0).getBoundingClientRect()
          editControl = @$('.js-card-menu').get(0)
          if editControl
            editControlRect = editControl.getBoundingClientRect()
            editControlRect.left - stickerRect.left
          else
            cardRect = @$el.get(0).getBoundingClientRect()
            cardRect.right - stickerRect.left
      }, sticker.id || sticker.cid
    @ensureSubviews(stickerSubViews, $stickers)

  else
    @$el.removeClass('is-stickered')
    $stickersArea.addClass('hide')

  @

module.exports.renderCustomFieldItems = ->
  subview = @subview CustomFieldBadgesView, @model
  @appendSubview subview, @$('.js-custom-field-badges')
  @

module.exports.renderPluginBadges = ->
  $pluginBadges = @$('.js-plugin-badges')
  @ensureSubviews [@subview(PluginBadgesView, @model)], $pluginBadges
  @

module.exports.renderPowerUpEffects = ->
  board = @model.getBoard()

  @$el.removeClass @model.getAllAgingClasses()

  isEvergreen = @model.getPluginDataByKey(
    CARD_AGING_POWER_UP_ID,
    'card',
    'shared',
    'evergreen',
    false
  )

  if board.isPowerUpEnabled('cardAging') &&
    !@model.get('closed') &&
    !isEvergreen
      data = @model.getAgingData()
      @$el.addClass data.agingClassesToAdd

module.exports.moveToCalendarDay = (e, ui, calendarDayView) ->
  calendarDayView.getCardView(@model).delegateEvents()
  targetDate = new Date(calendarDayView.data.day)
  @model.changeDueDateMaintainTime(targetDate)
  calendarDayView.updateHeader()
  calendarDayView.renderCardsAndListHeaders()

module.exports.moveInCalendarDay = (e, ui, calendarDayView) ->
  calendarDayView.getCardView(@model).delegateEvents()
  calendarDayView.renderCardsAndListHeaders()

module.exports.renderDueComplete = ->
  @$el.toggleClass('is-due-complete', @model.get('dueComplete'))
  @updateDueDate()
